import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["placeholder", "label", "helpText", "errorText", "type", "format", "icon", "cornerHint", "currency", "multiline", "rows", "showErrorIcon", "innerRef", "inputType", "currencyTypeChange", "disableSelect", "rightText", "disabled", "onBlur", "onKeyDown", "url", "dataCy", "tooltipHint", "hintText", "inputClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import classNames from 'classnames';
import { Icon } from '../../subkit-ui';
import { currencySymbols } from '../../utils/constants';
import Tooltip from '../../subkit-ui/basic/Tooltip/Tooltip';
import 'react-popper-tooltip/dist/styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TWInput = function TWInput(_ref) {
  var placeholder = _ref.placeholder,
      label = _ref.label,
      helpText = _ref.helpText,
      errorText = _ref.errorText,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'normal' : _ref$type,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'rounded' : _ref$format,
      icon = _ref.icon,
      cornerHint = _ref.cornerHint,
      currency = _ref.currency,
      multiline = _ref.multiline,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 3 : _ref$rows,
      _ref$showErrorIcon = _ref.showErrorIcon,
      showErrorIcon = _ref$showErrorIcon === void 0 ? false : _ref$showErrorIcon,
      innerRef = _ref.innerRef,
      _ref$inputType = _ref.inputType,
      inputType = _ref$inputType === void 0 ? 'text' : _ref$inputType,
      currencyTypeChange = _ref.currencyTypeChange,
      disableSelect = _ref.disableSelect,
      rightText = _ref.rightText,
      disabled = _ref.disabled,
      onBlur = _ref.onBlur,
      onKeyDown = _ref.onKeyDown,
      url = _ref.url,
      dataCy = _ref.dataCy,
      tooltipHint = _ref.tooltipHint,
      hintText = _ref.hintText,
      inputClassName = _ref.inputClassName,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(currency || 'usd'),
      selectedCurrency = _useState[0],
      setCurrency = _useState[1];

  var _useState2 = useState(false),
      passwordShown = _useState2[0],
      togglePasswordVisibility = _useState2[1];

  var finalType = inputType === 'password' ? passwordShown ? 'text' : 'password' : inputType;
  var baseStyle = generateStyles({
    type: type,
    format: format
  });

  var onCurrencyLabelChange = function onCurrencyLabelChange(event) {
    var value = event.target.value;
    setCurrency(value);
    currencyTypeChange && currencyTypeChange(value);
  };

  if (inputType === 'password' && icon) {
    icon.name = passwordShown ? 'eye-slash' : 'eye';
  }

  return /*#__PURE__*/_jsxs("div", {
    children: [label && /*#__PURE__*/_jsxs("div", {
      className: classNames('flex', {
        'flex-col': tooltipHint || hintText,
        'justify-between': cornerHint
      }),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex",
        children: [/*#__PURE__*/_jsx("label", {
          className: "block text-base font-medium text-gray-900",
          children: label
        }), !!tooltipHint && /*#__PURE__*/_jsx(Tooltip, {
          placement: "top",
          trigger: "hover",
          tooltip: tooltipHint,
          children: /*#__PURE__*/_jsx(Icon, {
            name: "question-circle",
            style: {
              color: 'gray'
            },
            type: "solid"
          })
        })]
      }), hintText && /*#__PURE__*/_jsx("span", {
        className: "text-base text-gray-500 my-1",
        children: hintText
      }), cornerHint && /*#__PURE__*/_jsx("span", {
        className: "text-base text-gray-500",
        children: cornerHint
      })]
    }), multiline ? /*#__PURE__*/_jsxs("div", {
      className: classNames('mt-1', {
        relative: showErrorIcon
      }),
      children: [/*#__PURE__*/_jsx("textarea", _objectSpread({
        className: classNames("".concat(baseStyle), {
          'bg-gray-50': disabled || props.readOnly
        }),
        placeholder: placeholder,
        "data-cy": dataCy,
        rows: rows,
        ref: innerRef
      }, props)), showErrorIcon && /*#__PURE__*/_jsx("div", {
        className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none",
        children: /*#__PURE__*/_jsx(Icon, {
          name: "exclamation-circle",
          style: {
            color: 'red'
          },
          type: "solid"
        })
      })]
    }) : /*#__PURE__*/_jsxs("div", {
      className: classNames('mt-1', {
        relative: currency || icon || showErrorIcon || rightText
      }, "".concat(inputClassName)),
      children: [rightText && /*#__PURE__*/_jsx("div", {
        className: "absolute inset-y-0 right-0 flex items-center",
        children: /*#__PURE__*/_jsx("span", {
          className: "absolute ml-8 inline-block pointer-events-none right-4",
          children: rightText
        })
      }), currency && /*#__PURE__*/_jsx("div", {
        className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
        children: /*#__PURE__*/_jsx("span", {
          className: "text-gray-500 text-sm md:text-base",
          children: currencySymbols[currency]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames('h-12', {
          'mt-1 flex flex-row rounded border border-neutral-200 overflow-hidden h-11': url
        }),
        children: [url && /*#__PURE__*/_jsx("div", {
          className: "flex items-center bg-neutral-100 h-full px-2.5 border border-t-0 border-l-0 border-b-0 border-neutral-200 text-neutral-400 font-sans",
          children: url
        }), /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
          className: classNames("".concat(baseStyle, " h-full"), {
            'bg-gray-50': disabled || props.readOnly,
            'appearance-none': !!currency,
            'pl-7': currency,
            'pr-10': !!rightText,
            'border-0 border-b-0': url,
            'border-red-600': Boolean(errorText)
          }),
          placeholder: placeholder,
          ref: innerRef,
          type: finalType,
          disabled: disabled,
          "data-cy": dataCy,
          onBlur: onBlur,
          onKeyDown: onKeyDown
        }, props), {}, {
          onChange: function onChange(e) {
            if (!props.onChange) return;
            if (type !== 'currency') return props.onChange(e); // for type=currency, only allow numeric input

            if (e.target.value.match(/[^0-9]+/)) return;
            return props.onChange(e);
          }
        }))]
      }), icon && /*#__PURE__*/_jsx("div", {
        className: classNames('absolute inset-y-0 right-0 pr-3 flex items-center', {
          clickable: inputType === 'password',
          'pointer-events-none': inputType !== 'password'
        }),
        children: /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, icon), {}, {
          onClick: function onClick() {
            return inputType === 'password' && togglePasswordVisibility(!passwordShown);
          }
        }))
      }), showErrorIcon && /*#__PURE__*/_jsx("div", {
        className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none",
        children: /*#__PURE__*/_jsx(Icon, {
          name: "exclamation-circle",
          style: {
            color: 'red'
          },
          type: "solid"
        })
      }), currency && /*#__PURE__*/_jsxs("div", {
        className: "absolute inset-y-0 right-0 flex items-center",
        children: [/*#__PURE__*/_jsx("label", {
          htmlFor: "currency",
          className: "sr-only",
          children: "Currency"
        }), /*#__PURE__*/_jsx("select", {
          id: "currency",
          name: "currency",
          className: "focus:outline-none focus:ring-1 focus:ring-subkit-primary focus:border-subkit-primary h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 text-sm md:text-base rounded-md appearance-none",
          onChange: onCurrencyLabelChange,
          value: selectedCurrency,
          disabled: disableSelect,
          children: Object.keys(currencySymbols).map(function (curr) {
            return /*#__PURE__*/_jsx("option", {
              value: curr,
              children: curr.toUpperCase()
            }, curr);
          })
        }), !disableSelect && /*#__PURE__*/_jsx("span", {
          className: "absolute pt-1 pl-8 inline-block h-full pointer-events-none",
          children: /*#__PURE__*/_jsx(Icon, {
            name: "chevron-down",
            type: "regular",
            className: "m-3 text-neutral-400"
          })
        })]
      })]
    }), errorText && /*#__PURE__*/_jsx("p", {
      className: "mt-2 text-sm text-red-600 block",
      children: errorText
    }), helpText && /*#__PURE__*/_jsx("p", {
      className: "mt-2 text-sm text-yellow-500",
      children: helpText
    })]
  });
};

var generateStyles = function generateStyles(_ref2) {
  var type = _ref2.type,
      format = _ref2.format;
  var baseStyle = 'p-2 shadow-sm block w-full text-base border';

  switch (type) {
    case 'normal':
      baseStyle = "".concat(baseStyle, " focus:outline-none focus:ring-1 focus:ring-subkit-primary focus:border-subkit-primary border-gray-300");
      break;

    case 'currency':
      baseStyle = "".concat(baseStyle, " focus:outline-none focus:ring-1 focus:ring-subkit-primary focus:border-subkit-primary border-gray-300 pr-16");
      break;

    case 'error':
      baseStyle = "".concat(baseStyle, " pr-10 border-red-300 text-red-900 focus:outline-none focus:ring-red-500 focus:border-red-500 ");
      break;

    case 'warning':
      baseStyle = "".concat(baseStyle, " border-yellow-300 text-yellow-900 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500");
      break;

    case 'no-focus':
      baseStyle = 'focus:outline-none';
      break;

    default:
      baseStyle = "".concat(baseStyle, " focus:outline-none focus:ring-1 focus:ring-subkit-primary focus:border-subkit-primary border-gray-300");
  }

  switch (format) {
    case 'rounded':
      baseStyle = "".concat(baseStyle, " rounded");
      break;

    case 'flat':
      baseStyle = "".concat(baseStyle, " rounded-none");
      break;

    case 'borderless':
      baseStyle = "".concat(baseStyle, " p-2 shadow-sm block w-full text-sm md:text-base border-r-0 border-l-0 border-t-0 border-gray-300");
      break;

    default:
      break;
  }

  return baseStyle;
};